import { Cta, FindPartners, Hero, HowItWorks, NewGenOffer, Payouts, WhyUs } from "@/widgets/sections";
import { Footer, Header } from "@/widgets/layout";
import { SignUpModal } from "@/widgets/modals/SignUpModal";
import { ContactModal } from "@/widgets/modals/ContactModal";

export function AffiliatePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <WhyUs />
        <NewGenOffer />
        <FindPartners />
        <HowItWorks />
        <Payouts />
        <Cta />
      </main>
      <Footer />
      <SignUpModal />
      <ContactModal />
    </>
  );
}
